export type IAgentActionKey = 'stopConversation' | 'addTag' | 'removeTag' | 'sendSMS' | 'addNote'

export type IAgentAction = {
  key: IAgentActionKey
  label: string
  template: string
}

type IMessageActionData = { content: string } | { auto: true }

export const stopConversationAction: IAgentAction = {
  key: 'stopConversation',
  label: 'Stop agent',
  template: '@stopConversation()',
}

export const createAddTagAction = (ids: number[]): IAgentAction => ({
  key: 'addTag',
  label: 'Add tag',
  template: `@addTag(${JSON.stringify({ ids })})`,
})

export const createRemoveTagAction = (ids: number[]): IAgentAction => ({
  key: 'removeTag',
  label: 'Remove tag',
  template: `@removeTag(${JSON.stringify({ ids })})`,
})

export const createAddContactNoteAction = (data: IMessageActionData): IAgentAction => ({
  key: 'addNote',
  label: 'Add contact note',
  template: `@addNote(${JSON.stringify(data)})`,
})

export const createSendSMSAction = (data: IMessageActionData): IAgentAction => ({
  key: 'sendSMS',
  label: 'Send SMS',
  template: `@sendSMS(${JSON.stringify(data)})`,
})

export const createActionChip = (action: IAgentAction): string => {
  const rootSpan = document.createElement('span')
  const wrapSpan = document.createElement('span')

  wrapSpan.className = 'actionChip-wrap'
  wrapSpan.setAttribute('data-readonly', '')
  wrapSpan.setAttribute('data-template', action.template)
  wrapSpan.setAttribute('contenteditable', 'false')

  const contentSpan = document.createElement('span')
  contentSpan.className = `actionChip-content actionChip-${action.key}`
  contentSpan.setAttribute('data-readonly', '')
  contentSpan.setAttribute('contenteditable', 'false')

  const iconSpan = document.createElement('span')
  iconSpan.className = `actionChip-icon actionChip-icon-${action.key}`
  iconSpan.setAttribute('contenteditable', 'false')

  const labelSpan = document.createElement('span')
  labelSpan.className = 'actionChip-label'
  labelSpan.setAttribute('contenteditable', 'false')
  labelSpan.innerText = action.label

  contentSpan.appendChild(iconSpan)
  contentSpan.appendChild(labelSpan)
  wrapSpan.appendChild(contentSpan)
  rootSpan.appendChild(wrapSpan)
  return rootSpan.innerHTML
}

const decodeHtmlEntities = (str: string): string =>
  str
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')

const dynamicActions: Array<
  [RegExp, (data: IMessageActionData | { ids: number[] }) => IAgentAction]
> = [
  [/^@addTag\((.+)\)$/, (data) => createAddTagAction((data as { ids: number[] }).ids)],
  [/^@removeTag\((.+)\)$/, (data) => createRemoveTagAction((data as { ids: number[] }).ids)],
  [/^@addNote\((.+)\)$/, (data) => createAddContactNoteAction(data as IMessageActionData)],
  [/^@sendSMS\((.+)\)$/, (data) => createSendSMSAction(data as IMessageActionData)],
]

export const actionChipReplacer = (template: string) => {
  const decoded = decodeHtmlEntities(template)
  if (decoded === stopConversationAction.template) return createActionChip(stopConversationAction)

  for (const [pattern, createAction] of dynamicActions) {
    const match = decoded.match(pattern)
    if (match) {
      try {
        return createActionChip(createAction(JSON.parse(match[1])))
      } catch {
        return template
      }
    }
  }
  return template
}
